import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material"
import React from "react"
import { NavLink } from "react-router-dom"

import { ItemWithSubItems } from "./ItemWithSubItems"

export const ItemMenu = ({ item, itemSelected, setItemSelected }) => {
  return item.subItems.length > 0 ? (
    <ItemWithSubItems
      item={item}
      itemSelected={itemSelected}
      setItemSelected={setItemSelected}
    />
  ) : (
    <NavLink to={item.href} style={{ textDecoration: "none" }}>
      <ListItemButton
        key={item.label}
        sx={{
          py: 0,
          minHeight: 40,
          color: "rgba(255,255,255,.8)",
          backgroundColor: item.type === itemSelected ? "#E6E6E6" : null,
          borderLeft: item.type === itemSelected ? "4px solid #25D9A6" : null,
        }}
        onClick={() => {
          setItemSelected(item.type)
        }}
      >
        <ListItemIcon sx={{ color: "#00bcaa" }}>{item.icon}</ListItemIcon>
        <ListItemText
          primary={item.label}
          primaryTypographyProps={{
            fontSize: 16,
            fontWeight: "medium",
            color: "#263057",
          }}
        />
      </ListItemButton>
    </NavLink>
  )
}
